//
//
//
//
//
//
//
//
//
//
//
//

import { getUserCert } from '@/api/pengchengxinli'
export default {
  data () {
    return {
      type: '' // 1|医生 2|普通用户
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  mounted () {
    this.getType()
  },
  methods: {
    // 获取用户角色
    getType () {
      getUserCert({
        userId: this.accountid
      }).then(res => {
        if (res.success === true) {
          this.type = res.obj.type
          //   this.type = 1
          this.$store.commit('setUserCertType', this.type)
        }
      })
    }
  }
}
